import ResendSharingLoggedInPage from "./ResendSharingLoggedInPage";

export default ResendSharingLoggedInPage;
